import React, { useState } from "react";

// @ mui icons
import FilterListIcon from "@mui/icons-material/FilterList";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PlayForWorkIcon from "@mui/icons-material/PlayForWork";
import QcFilterForm from "../components/Qc/QcFilterForm";

// common components
import TableHeader from "../components/common/MagicTableHeader";
import Header from "../components/common/MagicPageHeader";
import MagicDrawer from "../components/common/MagicDrawer_new";
import Table from "../components/common/MagicTable";
import Stack from "../components/mui/Stack";
import Button from "../components/mui/Button";

const QcContainer: React.FC = () => {
  const [isOpenFilterForm, setIsOpenFilterForm] = useState<boolean>(false);
  const [filter, setFilter] = useState({
    center: "",
  });
  // const [currentPage, setCurrentPage] = useState<number>(0);
  // const pageSize = 5
  // const displayedRows = rows.slice(currentPage * pageSize, (currentPage + 1) * pageSize);
  const toggleFilerFormDrawer = () => {
    setIsOpenFilterForm((preState) => !preState);
  };

  const handleDownloadBtnClick = () => {
    console.log("Hit approve data btn");
  };

  const handleImportBtnClick = () => {
    console.log("Hit Import btn");
  };

  const handleApplyFilterBtn = (): void => {
    console.log("Hit apply filter btn");
  };

  const handleClearAllFilterBtn = (): void => {
    console.log("Hit apply filter btn");
  };
  const handleSearch = (value: string | number) => {
    console.log("Searching value -->", value);
  };

  const handlePagination = (event: any, pageNo: number) => {
    console.log("current page no. --->", pageNo);
    // setCurrentPage(newPage);
  };

  // Header Button
  const magicPageHeaderBtn = [
    {
      text: "Download",
      variant: "contained",
      startIcon: <PlayForWorkIcon />,
      onClick: handleDownloadBtnClick,
      sx: {
        background: "white",
        color: "black",
        textTransform: "capitalize",
        border: "1px solid rgb(176, 152, 65)",
        padding: "4.7px 16px",
      },
    },
  ];

  const magicTableHeaderBtn = [
    {
      text: "Add Filters",
      variant: "outlined",
      startIcon: <FilterListIcon />,
      onClick: toggleFilerFormDrawer,
      sx: {
        color: "black",
        textTransform: "capitalize",
        border: "1px solid rgb(204, 204, 204)",
      },
    },
  ];

  const columns = [
    {
      field: "parameter",
      headerName: "Parameter",
      width: 250,
    },
    {
      field: "centre",
      headerName: "Centre",
      minWidth: 343,
    },
    {
      field: "quarter1",
      headerName: "Quarter 1",
      minWidth: 160,
    },
    {
      field: "quarter2",
      headerName: "Quarter 2",
      minWidth: 160,
    },
    {
      field: "quarter3",
      headerName: "Quarter 3",
      minWidth: 150,
    },
    {
      field: "quarter4",
      headerName: "Quarter 4",
      minWidth: 150,
    },
  ];

  const rows = [
    {
      id: 1, // Ensure each row has a unique ID
      parameter: "North",
      centre: "North Centre A",
      quarter1: "NC001",
      quarter2: "2020-2025",
      quarter3: "Funder A",
      quarter4: "District 1",
    },
    {
      id: 2,
      parameter: "North",
      centre: "North Centre A",
      quarter1: "NC001",
      quarter2: "2020-2025",
      quarter3: "Funder A",
      quarter4: "District 2",
    },
    {
      id: 3,
      parameter: "North",
      centre: "North Centre A",
      quarter1: "NC001",
      quarter2: "2020-2025",
      quarter3: "Funder A",
      quarter4: "District 3",
    },
    {
      id: 4,
      parameter: "North",
      centre: "North Centre A",
      quarter1: "NC001",
      quarter2: "2020-2025",
      quarter3: "Funder A",
      quarter4: "District 4",
    },
    {
      id: 5,
      parameter: "North",
      centre: "North Centre A",
      quarter1: "NC001",
      quarter2: "2020-2025",
      quarter3: "Funder A",
      quarter4: "District 5",
    },
    {
      id: 6,
      parameter: "East",
      centre: "North Centre A",
      quarter1: "NC001",
      quarter2: "2020-2025",
      quarter3: "Funder A",
      quarter4: "District 6",
    },
    {
      id: 7,
      parameter: "North",
      centre: "North Centre A",
      quarter1: "NC001",
      quarter2: "2020-2025",
      quarter3: "Funder A",
      quarter4: "District 7",
    },
    {
      id: 8,
      parameter: "North",
      centre: "North Centre A",
      quarter1: "NC001",
      quarter2: "2020-2025",
      quarter3: "Funder A",
      quarter4: "District 8",
    },
  ];

  const ratiobtn = [
    { label: "All", value: "all" },
    { label: "East", value: "east" },
    { label: "West", value: "west" },
    { label: "North", value: "north" },
    { label: "South", value: "south" },
  ];
  const centerList = {
    centerSelect: [
      { id: "center1", label: "Center 1" },
      { id: "center2", label: "Center 2" },
    ],
  };
  const handleFilterFormChange = (field: string, value: any) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [field]: value,
    }));
  };
  return (
    <>
      <Stack>
        <Header
          title="Quarter wise comparison"
          subTitle="Here you can view the Quarter wise comparison."
          buttons={magicPageHeaderBtn}
          chipLabel="400 entries"
        />

        <TableHeader
          buttons={magicTableHeaderBtn}
          onSearchfieldChange={handleSearch}
        />

        <Table
          columns={columns}
          rows={rows}
          loading={false}
          count={4}
          rowCellsSx={{ paddingLeft: "16px", textAlign: "start" }}
          headerSx={{
            paddingLeft: "16px",
            textAlign: "start",
            fontWeight: 600,
            color: "#242424",
            padding: "13px 16px",
          }}
          tableSx={{ width: "100%", overflowz:"auto" , maxHeight:"300px"}}
          handlePageChange={handlePagination}
          sx={{
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#DADADA",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 550,
              fontSize: "14px",
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDataGrid-cell": {
              display: "flex",
              alignItems: "center",
            },
          }}
        />

        <MagicDrawer
          title="Add Filters"
          subtitle="See the data in an organized manner by applying filters"
          drawerOpen={isOpenFilterForm}
          onDrawerToggle={toggleFilerFormDrawer}
          actionComponent={() => (
            <>
              <Button
                className="bun-outline"
                onClick={handleClearAllFilterBtn}
                // disabled={isFetchingUserData}
              >
                Clear All
              </Button>
              <Button
                className="bun-filled"
                onClick={handleApplyFilterBtn}
                // loading={isFetchingUserData}
              >
                Done
              </Button>
            </>
          )}
        >
          <QcFilterForm
            ratiobtn={ratiobtn}
            centerList={centerList}
            filter={filter}
            handleFilterFormChange={handleFilterFormChange}
          />
        </MagicDrawer>
      </Stack>
    </>
  );
};

export default QcContainer;
